import React from 'react';
import OverviewDashboard from '../overview/OverviewDashboard';
import TeamHierarchy from './TeamHierarchy';
import useTabFromUrl from '../../hooks/useTabFromUrl';

/**
 * Director/VP view. Overview tab uses same dashboard layout as Unit Manager with scope="system".
 */
function DirectorView({ user, initialTab }) {
  const [activeTab] = useTabFromUrl(initialTab || 'overview');

  return (
    <div className="tab-content">
      {activeTab === 'overview' && (
        <div className="dashboard-container">
          <div className="dashboard-header">
            <h1 className="dashboard-title">Overview</h1>
            <p className="dashboard-subtitle">System-wide focus and operational signals</p>
          </div>
          <OverviewDashboard scope="system" />
        </div>
      )}
      {activeTab === 'hierarchy' && (
        <div className="dashboard-container">
          <TeamHierarchy serviceLineId={user.serviceLineId} />
        </div>
      )}
    </div>
  );
}

export default DirectorView;
